<template>
  <div style="background:#f5f5f5;padding-bottom:30px;">
     <member-header></member-header> 
    <div class="order_details_title">
      <span>个人中心 > </span>
      <span>我的订单 > </span>
      <span>订单号：{{orderData.scode}} </span>
    </div>
    <div class="order_details">
      <div class="order_details_step clearfix_">
        <div class="fl step_state">
          <p class="state_">
            {{orderData.status==1?'待分享':''}}
            {{orderData.status==2?'已成团':''}}
            {{orderData.status==3?'失败团':''}}
            {{orderData.status==4?'历史成团':''}}
          </p>
          <p style="text-align:center;">
            <span v-show="orderData.status==1" class="btn_"><router-link tag="a" target="_blank" :to="{name:'theFinalResults',query: {id:orderData.retailSpellGroupOrderId}}">邀请好友</router-link></span>
            <span v-show="orderData.status!=1" class="btn_"><router-link tag="a" target="_blank" :to="{name:'theFinalResults',query: {id:orderData.retailSpellGroupOrderId}}">拼团详情</router-link></span>
          </p>
          <p class="clearfix_">
            <span class="printing_">打印订单</span>
            <i class=""></i>
            <span class="complaint_">投诉商家</span>
          </p>
        </div>
        <div class="fl step_">
          <ul style="margin-left:10px;" class="clearfix_">
            <li class="fl step_no">
              <div>
                <p>提交订单</p>
                <div class="clearfix_">
                  <i :class="{color:orderData.orderStatus>0}" style="margin-left:82px;" class="fl">1</i>
                  <span :class="{background:orderData.orderStatus>0}" class="fl"></span>
                </div>
              </div>
            </li>
            <li class="fl step_no">
              <div>
                <p>支付订单</p>
                <div class="clearfix_">
                  <span :class="{background:orderData.orderStatus>1}" class="fl"></span>
                  <i :class="{color:orderData.orderStatus>1}" class="fl">2</i>
                  <span :class="{background:orderData.orderStatus>1}" class="fl"></span>
                </div>
              </div>
            </li>
            <li class="fl step_no">
              <div>
                <p>商家发货</p>
                <div class="clearfix_">
                  <span :class="{background:orderData.orderStatus>2}" class="fl"></span>
                  <i :class="{color:orderData.orderStatus>2}" class="fl">3</i>
                  <span :class="{background:orderData.orderStatus>2}" class="fl"></span>
                </div>
              </div>
            </li>
            <li class="fl step_no">
              <div>
                <p>完成收货</p>
                <div class="clearfix_">
                  <span :class="{background:orderData.orderStatus>3}" class="fl"></span>
                  <i :class="{color:orderData.orderStatus>3}" class="fl">4</i>
                  <span :class="{background:orderData.orderStatus>3}" class="fl"></span>
                </div>
              </div>
            </li>
            <li class="fl step_no">
              <div>
                <p>评价</p>
                <div class="clearfix_">
                  <span :class="{background:orderData.orderStatus>4}" class="fl"></span>
                  <i :class="{color:orderData.orderStatus>4}" class="fl">5</i>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="order_information">
        <p class="order_title_">订单信息</p>
        <ul class="clearfix_">
          <li class="fl">订单编号：<span>{{orderData.scode}}</span></li>
          <li class="fl">下单时间：<span>{{orderData.time}}</span></li>
          <li class="fl">商户：<span>{{orderData.tenantName}}</span></li>
          <li class="fl">收货人地址：<span>{{orderData.address}}</span></li>
          <li class="fl">收货人信息：<span>{{orderData.recipient}} {{orderData.mobilePhone}}</span></li>
          <li class="fl" v-if="orderData.payType">
            支付方式：
            <span v-if="orderData.payType==1">货到付款</span>
            <span v-if="orderData.payType==2">余额支付</span>
            <span v-if="orderData.payType==3">微信</span>
            <span v-if="orderData.payType==4">银联</span>
            <span v-if="orderData.payType==5">卡支付</span>
            <span v-if="orderData.payType==6">支付宝</span>
            <span v-if="orderData.payType==7">pos通</span>
          </li>
        </ul>
      </div>
      <div>
        <div class="order_goods_information">
          <p class="order_goods_title">商品信息</p>
          <div class="order_goods_explain clearfix_">
            <p class="fl goodsName">商品名称</p>
            <p class="fl price">单价</p>
            <p class="fl num">数量</p>
            <p class="fl subtotal">小计</p>
            <p class="fl integral">商品积分</p>
            <p class="fl mode">优惠方式</p>
            <p class="fl operation">商品操作</p>
          </div>
        </div>
        <ul class="order_goods_information_ul">
          <li class="clearfix_">
            <img class="fl" :src="orderData.pic?orderData.pic:timg" alt="">
            <p @click="toGoods(orderData.domain,orderData.goodsId)" class="goodsName fl">{{orderData.goodsName}}<br/>{{orderData.goodsUnitName}};{{orderData.property1}}</p>
            <p class="price fl">¥{{orderData.salesMoney}}</p>
            <p class="num fl">{{orderData.num}}</p>
            <p class="fl subtotal">{{orderData.totalPrice}}</p>
            <p class="fl integral">{{orderData.memberScore}}</p>
            <p class="fl mode">
              <!-- <span v-show="item.privilegePrice!='0.00'">优惠{{item.privilegePrice}}</span><br v-show="item.privilegePrice!='0.00'">
              <span v-show="item.score">{{item.score}}分</span><br v-show="item.score">
              <span v-show="item.giftNum">赠{{item.giftNum}}</span> -->
            </p>
            <p class="operation fl clearfix_">
              <!-- <span class="fl" v-show="item.returnStatus==2" @click="replacementGoods(state_,item.id,item.returnNumber,item.returnTypeId)">退货/退款</span> -->
            </p>
          </li>
        </ul>
      </div>
      <div class="order_goods_algorithm clearfix_">
        <ul class="fr">
          <li class="clearfix_">
            <p class="fl name_">商品总额</p>
            <p class="fr price_">{{orderData.totalAmount}}</p>
          </li>
           <li v-show="parseInt(orderData.memberPrivilege)" class="clearfix_">
            <p class="fl name_">会员优惠</p>
            <p class="fr price_">{{orderData.memberPrivilege}}</p>
          </li> 
          <li v-show="parseInt(orderData.privilege)" class="clearfix_">
            <p class="fl name_">单品优惠</p>
            <p class="fr price_">{{orderData.privilege}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">运费</p>
            <p class="fr price_">{{orderData.postageMoney}}</p>
          </li>
          <li class="clearfix_">
            <p class="fl name_">商品数量</p>
            <p class="fr price_">{{orderData.num}}</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import memberHeader from '@/components/member/member_header'
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  components:{
		memberHeader
  },
  data(){
    return {
      orderData:{},
      timg:require('../../assets/img/timg.gif'),
      state_:0,
      logisticsList:[],
      logisticsBlock:false,
      pmnGiftDataLength:true,
      promotionDataLength:true
    }
  },
  mounted:function(){
    var t_=this
    t_.getOrder()
  },
  methods:{
    toGoods:function(web,id,name){
      var t_=this
      var url='http://'+web+'/goodsdetails?goodsId='+id
      window.open(url,'_blank')
    },
    getOrder:function(){
      var t_=this
      var data0bj=Qs.stringify({
        tamp:localStorage.tamp?localStorage.tamp:'',
        channel:2,
        id:t_.$route.query.id
      })
      axios.post(`${ip}spellGroupInterface/getOrderById`,data0bj).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
          t_.orderData=res.data.retailSpellGroupOrderItemData
        }
      })
    }
  }
}
</script>

<style scoped>
  .order_details_title{
    height: 40px;
    width: 1200px;
    margin: 0 auto;
    line-height: 40px;
    color:#333;
  }
  .order_details{
    width: 1198px;
    border: 1px solid #ddd;
    margin: 0 auto;
    background: #fff;
  }
  .order_details_step{
    height: 218px;
    border-bottom: 1px solid #ddd;
    margin-bottom: 20px;
  }
  .step_state{
    width: 258px;
    height: 145px;
    border-right: 1px solid #ddd;
    padding-top: 73px;
  }
  .step_state .state_{
    text-align: center;
    font-size:18px;
    color:#333;
    margin-bottom: 23px;
  }
  .step_state .btn_{
    width: 65px;
    height: 22px;
    text-align: center;
    line-height: 22px;
    border: 1px solid #ddd;
    border-radius: 3px;
    margin: 0 auto;
    cursor: pointer;
    display: inline-block;
  }
  .step_state .btn_:hover{
    color:#f60;
  }
  .step_state p:last-child{
    margin-top: 58px;
    text-align: center;
  }
  .step_state .printing_{
    color:#f60;
  }
  .step_state i{
    width: 2px;
    height: 12px;
    background: #cecece;
    margin:0 5px;
    display: inline-block;
  }
  .order_details_step .step_{
    width: 939px;
    height: 149px;
    padding-top: 69px;
  }
  .order_details_step .step_ li{
    width: 184px;
    height: 122px;
  }
  .order_details_step .step_ li span{
    width:82px;
    height: 6px;
    background: #ababab;
    margin-top: 7px;
  }
  .order_details_step .step_ li .background{
    background: #2abf5c; 
  }
  .order_details_step .step_ li i{
    width: 14px;
    height: 14px;
    border: 3px solid #ababab;
    border-radius: 50%;
    text-align: center;
    line-height: 14px;
    color:#ababab;
  }
  .order_details_step .step_ li .color{
    color:#2abf5c;
    border: 3px solid #2abf5c;
  }
  .order_details_step .step_ li p{
    margin: 13px 0;
    text-align: center;
  }
  .order_information{
    margin-left:40px;
    margin-bottom: 20px;
  }
  .order_title_{
    color:#333;
    margin-bottom: 18px;
  }
  .order_information li{
    width: 50%;
    margin-bottom: 13px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
    color:#999;
  }
  .order_information li span{
    color:#333;
  }
  .order_goods_information{
    margin-left:40px;
    margin-bottom: 20px;
  }
  .order_goods_title{
    color:#333;
    margin-bottom: 10px;
  }
  .order_goods_explain{
    width: 1100px;
    height: 30px;
    background: #f5f5f5;
    color:#333;
  }
  .order_goods_information .activity p{
    width: 25%;
    height: 20px;
    line-height: 20px;
    text-align: center;
  }
  .activityDetailed{
    margin-left: 40px;
  }
  .activityDetailed p{
    width: 25%;
    text-align: center;
    height: 20px;
    line-height: 20px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
  }
  .order_goods_explain p{
    line-height: 30px;
  }
  .order_goods_explain .goodsName{
    width: 300px;
    text-align: center;
    cursor: pointer;
    /* margin: 0 106px 0 82px; */
  }
  .order_goods_explain .price,.order_goods_explain .num{
    width: 130px;
    text-align: center;
  }
  .order_goods_explain .operation{
    width: 130px;
    text-align: center;
  }
  .order_goods_explain .mode{
    width: 130px;
    text-align: center;
  }
  .order_goods_explain .integral{
    width: 130px;
    text-align: center;
  }
  .order_goods_explain .subtotal{
    width: 130px;
    text-align: center;
  }
  .order_goods_information_ul{
    width: 1100px;
    margin-left: 40px;
    border-bottom: 1px solid #eee;
    margin-bottom: 25px;
  }
  .order_goods_information_ul li{
    margin-bottom: 20px;
  }
  .order_goods_information_ul img{
    width: 62px;
    height: 62px;
    margin-right: 20px;
  }
  .order_goods_information_ul .goodsName{
    width: 218px;
    line-height: 20px;
    height: 62px;
    cursor: pointer;
  }
  .order_goods_information_ul .price,.order_goods_information_ul .num,.order_goods_information_ul .subtotal,.order_goods_information_ul .integral,.order_goods_information_ul .mode{
    width: 130px;
    height: 62px;
    text-align: center;
  }
  .order_goods_information_ul .mode{
    line-height: 18px;
  }
  .order_goods_information_ul .operation{
    width: 130px;
    height: 62px;
    text-align: center;
  }
  .order_goods_information_ul .operation span{
    line-height: 18px;
    cursor: pointer;
    width: 100%;
  }
  .order_goods_algorithm{
    width: 1100px;
    margin-left: 40px;
    margin-bottom: 40px;
  }
  .order_goods_algorithm ul{
    width: 230px;
  }
  .order_goods_algorithm li{
    margin-bottom: 10px;
  }
  .order_logistics{
    width: 1100px;
    margin-left:40px;
    min-height: 185px;
    border: 1px solid #ddd;
    margin-bottom: 30px;
  }
  .order_logistics_title{
    margin-left:40px;
    margin-bottom: 12px;
  }
  .order_logistics_title span{
    cursor: pointer;
  }
  .order_logistics_package{
    height: 35px;
    background: #f8f8f8;
    margin-bottom: 10px;
  }
  .order_logistics_package p{
    line-height: 35px;
  }
  .order_logistics_package .txt1{
    margin-left: 10px;
    margin-right: 15px;
    font-weight: 900;
    color:#333;
  }
  .order_logistics_package .txt2{
    color:#999;
    margin-right: 25px;
  }
  .order_logistics_package .txt3{
    margin-right: 10px;
  }
  .order_logistics_package .txt4{
    margin-right: 15px;
  }
  .order_logistics_imgs{
    margin-left: 40px;
  }
  .order_logistics_imgs img{
    width:62px;
    height: 62px;
    margin-right: 12px;
    margin-bottom: 5px;
  }
  .order_logistics ul{
    margin-left:14px;
  }
  .order_logistics li{
    height: 27px;
  }
  .order_logistics li p{
    line-height: 27px;
  }
  .order_logistics li .txt1{
    width: 138px;
    border-right:1px solid #ddd;
    margin-right: 20px;
  }
  .order_logistics_more{
    color:#28e;
    text-align: center;
    height: 22px;
    line-height: 22px;
    background: #f8f8f8;
  }
  .order_logistics_more span{
    cursor: pointer;
  }
</style>




// WEBPACK FOOTER //
// src/components/member/team_order_details.vue